import * as marietta from '../../..';
import { Dialog } from '../../../core/view';

/**
 * 部屋塗色設定ダイアログ
 */
class RoomFillDialog extends Dialog {
    currentItem: marietta.webcad.item.Room;

    color: string;

    designColor: string;

    designType: string;

    /**
     * コンストラクタ
     */
    constructor(draggable: boolean) {
      super(draggable);

      if (!(marietta.webcad.WebCADGlobal.itemManager.currentItem instanceof marietta.webcad.item.Room)) return;
      this.currentItem = marietta.webcad.WebCADGlobal.itemManager.currentItem as marietta.webcad.item.Room;
      this.color = this.currentItem.itemInfo.color;
      this.designColor = this.currentItem.itemInfo.designColor;
      this.designType = this.currentItem.itemInfo.design_type;

      // ダイアログのコンテンツ生成
      const id = 'roomFillDialog';
      let title = '';
      // タイトル
      switch (marietta.webcad.WebCADGlobal.language) {
        case 'en': title = 'Design Setting'; break;
        default: title = '色設定'; break;
      }

      let contents = '<div class="dialogRoomFill">\n';
      contents += '<table style="display:inline-block">\n';
      contents += '<tbody >\n';
      contents += '<tr>\n';
      contents += '<th><span class="jp">背景色：</span><span class="en">Fill Color:</span></th>\n';
      contents += '<td><input type="color" value="#e66465" id="colorPickerBg" /></td>\n';
      contents += '</tr>\n';
      contents += '<tr>\n';
      contents += '<th><span class="jp">模様色：</span><span class="en">Pattern Color:</span></th>\n';
      contents += '<td><input type="color" value="#e66465" id="designColorPickerBg" /></td>\n';
      contents += '</tr>\n';
      contents += '</tbody>\n';
      contents += '</table>\n';
      contents += '<canvas id="preview-canvas" width="120" height="80"></canvas>\n';
      contents += '<div id="roomFillDialogTextureList">\n';
      contents += '</div>\n';
      contents += '</div>';
      let footer = '<div class ="resetRoomFill"><button id="btnResetRoomFill"><span class="jp">初期設定に戻す</span><span class="en">Reset</span></button></div>';
      footer += '<button id="btnDoneRoomFill"><span class="jp">ＯＫ</span><span class="en">OK</span></button>';
      footer += '<button id="btnClose"><span class="jp">キャンセル</span><span class="en">Cancel</span></button>';

      this.createDialog(id, title, contents, footer);

      // テクスチャリスト生成
      this.createTextureList();

      // イベント設定
      const btn = document.querySelector('#btnDoneRoomFill');
      btn.addEventListener('click', this.btnOKClickHandler);

      document.getElementById('btnClose').addEventListener('click', () => {
        marietta.webcad.WebCADGlobal.removeDialog();
      });
      (<HTMLInputElement>document.getElementById('colorPickerBg')).value = this.color;
      (<HTMLInputElement>document.getElementById('designColorPickerBg')).value = this.designColor;

      (<HTMLInputElement>document.getElementById('colorPickerBg')).addEventListener('change', (e) => {
        this.color = (<HTMLInputElement>e.target).value;
        this.previewSelectedTexture();
      }, false);
      (<HTMLInputElement>document.getElementById('designColorPickerBg')).addEventListener('change', (e) => {
        this.designColor = (<HTMLInputElement>e.target).value;
        this.previewSelectedTexture();
      }, false);

      const btnReset = document.querySelector('#btnResetRoomFill');
      btnReset.addEventListener('click', this.resetRoomFill);
      this.previewSelectedTexture();
    }

    resetRoomFill = () => {
      const info = marietta.webcad.WebCADGlobal.getRoomConfig(this.currentItem.itemInfo.id);
      this.color = info.color;
      this.designColor = info.designColor;
      this.designType = info.design_type;
      (<HTMLInputElement>document.getElementById('colorPickerBg')).value = this.color;
      (<HTMLInputElement>document.getElementById('designColorPickerBg')).value = this.designColor;
      this.showSelectTexture(this.designType);
    }

    /**
     * パターンのテクスチャ設定
     */
    setDesignType = (e) => {
      e.preventDefault();
      const src = e.currentTarget.querySelector('img').getAttribute('src').split(`${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}texture/`)[1];
      if (src.split('.png')[0] === 'no_pattern') {
        this.designType = null;
      } else {
        this.designType = src.split('.png')[0] as any;
      }
      // 選択中のテクスチャをリストに表示
      this.showSelectTexture(this.designType);
      // this.previewSelectedTexture();
    }

    /**
     * パターンのテクスチャリスト作成
     */
    createTextureList() {
      // TODO: 後でテクスチャリストの取得方法変更
      const textureList = [
        `${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}texture/koushi_1.png`,
        `${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}texture/koushi_2.png`,
        // marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url + 'texture/koushi_3.png',
        `${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}texture/pattern_4.png`,
        `${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}texture/pattern_6.png`,
        // marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url + 'texture/pattern_7.png',
        // marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url + 'texture/pattern_8.png',
        `${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}texture/pattern_9.png`,
        `${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}texture/pattern_10.png`,
        // marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url + 'texture/pattern_34.png',
        `${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}texture/no_pattern.png`,
      ];

      const target = document.querySelector('#roomFillDialogTextureList');
      const ulElem = document.createElement('ul');
      ulElem.classList.add('cf');

      // テクスチャボタン作成
      const liElem = document.createElement('li');
      const aElem = document.createElement('a');
      const imgElem = document.createElement('img');
      liElem.appendChild(aElem).appendChild(imgElem);
      aElem.setAttribute('href', '');

      for (let i = 0, len = textureList.length; i < len; i += 1) {
        const el = liElem.cloneNode(true);
        (<any>el).querySelector('img').setAttribute('src', textureList[i]);
        (<any>el).querySelector('img').setAttribute('width', 60);
        (<any>el).querySelector('img').setAttribute('height', 60);
        ulElem.appendChild(el);
      }
      liElem.remove();
      target.appendChild(ulElem);

      if (textureList.indexOf(`${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}texture/${this.designType}.png`) === -1) this.designType = null;

      const self = this;
      document.getElementById('roomFillDialogTextureList').querySelectorAll('a').forEach((element) => {
        element.addEventListener('click', self.setDesignType);
      });
      // 選択中のテクスチャをリストに表示
      this.showSelectTexture(this.currentItem.itemInfo.design_type);
    }

    /**
     * 選択中のテクスチャをリストに表示
     */
    showSelectTexture(designType: string) {
      // 初期化
      document.getElementById('roomFillDialogTextureList').querySelectorAll('li').forEach((element) => {
        element.classList.remove('is-active');
      });

      document.getElementById('roomFillDialogTextureList').querySelectorAll('img').forEach((element) => {
        const textureName = element.getAttribute('src');
        if (designType == null && textureName.indexOf('no_pattern') > -1) {
          element.parentElement.parentElement.classList.add('is-active');
          return;
        }
        if (textureName.indexOf(designType) > -1) {
          element.parentElement.parentElement.classList.add('is-active');
        }
      });
      this.previewSelectedTexture();
    }

    /**
     * OKボタン
     */
    btnOKClickHandler = (e: MouseEvent) => {
      e.preventDefault();
      this.currentItem.changeRoomPattern(this.color, this.designType, this.designColor);

      // パネルを閉じる
      marietta.webcad.WebCADGlobal.removeDialog();

      marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
    }

    /**
     * 選択したパターンのプレビュー
     */
    previewSelectedTexture() {
      const patternImage = new Image();
      patternImage.crossOrigin = 'anonymous';
      if (this.designType != null) {
        patternImage.src = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}texture/${this.designType}.png`;
        const scope = this;
        patternImage.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = 60;
          canvas.height = 60;
          const ctx = canvas.getContext('2d');
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(patternImage, 0, 0, patternImage.width, patternImage.height, 0, 0, 60, 60);
          const imgdata = ctx.getImageData(0, 0, patternImage.width, patternImage.height);
          // HEXの色をRGBに変換
          const patternColor: marietta.webcad.collection.ColorRGB = marietta.webcad.util.ColorUtil.convertToRGB(scope.designColor);
          for (let i = 0; i < imgdata.data.length; i += 4) {
            imgdata.data[i] = patternColor._r;
            imgdata.data[i + 1] = patternColor._g;
            imgdata.data[i + 2] = patternColor._b;
          }
          ctx.putImageData(imgdata, 0, 0);
          const newImage = canvas.toDataURL('image/png');
          const image = new Image();
          image.src = newImage;
          setTimeout(image.onload = () => {
            const c: HTMLCanvasElement = <HTMLCanvasElement>document.getElementById('preview-canvas');
            const context = c.getContext('2d');
            context.clearRect(0, 0, 120, 80);
            const pat = context.createPattern(image, 'repeat');
            context.fillRect(0, 0, 120, 80);
            context.fillStyle = pat;
            context.fill();
            c.style.backgroundColor = scope.color;
          }, 100);
        };
      } else {
        const c: HTMLCanvasElement = <HTMLCanvasElement>document.getElementById('preview-canvas');
        const context = c.getContext('2d');
        context.clearRect(0, 0, 120, 80);
        c.style.backgroundColor = this.color;
      }
    }
}
export default RoomFillDialog;
